import { render, staticRenderFns } from "./LabelSidebarSection.vue?vue&type=template&id=2c659a65&"
import script from "./LabelSidebarSection.vue?vue&type=script&lang=js&"
export * from "./LabelSidebarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports